@if (sessionService.profile()) {
<form
  [formGroup]="messageForm"
  (ngSubmit)="disabled() ? null : send()"
  class="input-container flex items-center"
  [class.disabled]="disabled()"
>
  <input
    ngpInput
    name="message"
    [formControl]="messageControl"
    #messageRef
    type="text"
    autocomplete="off"
    [disabled]="disabled()"
    placeholder="Send message..."
  />
  <button
    type="button"
    [ngpPopoverTrigger]="popover"
    [ngpPopoverTriggerOffset]="12"
    class="button s-24 button--style-gray-08"
    [disabled]="disabled()"
  >
    <svg-icon
      class="flex items-center justify-center s-16"
      src="assets/icons/ui/emoji.svg"
    />
  </button>

  <button
    type="submit"
    class="button s-24 button--style-gray-08"
    [disabled]="disabled()"
  >
    <svg-icon
      class="flex items-center justify-center s-16"
      src="assets/icons/ui/send.svg"
    />
  </button>
  <ng-template #popover>
    <div ngpPopover class="emotes-list scrollbar">
      @for (emote of chatService.emotes(); track $index) {
      <div
        (click)="handleSelectEmote(emote.key)"
        class="emote flex items-center justify-center s-36 rounded-4 padding-4"
      >
        <img [src]="emote.image" />
      </div>
      }
    </div>
  </ng-template>
</form>

<ng-content select="[extra-actions]" />
} @else {
<app-login-button class="w-full" />
}
